// src/components/Leadership/LeadershipOwnership.js
import React from 'react';
import { Target, Users, Grid3x3 } from 'lucide-react';
import '../../styles/Leadership/LeadershipOwnership.css';

const LeadershipOwnership = () => {
  const ownershipPillars = [
    {
      icon: <Target className="pillar-icon" />,
      title: "Clear Accountability",
      description: "Defined ownership and measurable outcomes for every engagement.",
      features: [
        "Named delivery owners for each workstream",
        "RACI matrix for decision clarity",
        "Outcome-based success metrics"
      ],
      color: "from-blue-600 to-indigo-600"
    },
    {
      icon: <Users className="pillar-icon" />,
      title: "Executive Alignment",
      description: "Translating delivery into board‑ready KPIs and governance reports.",
      features: [
        "Monthly executive briefings",
        "Strategic roadmap alignment",
        "Board-ready documentation"
      ],
      color: "from-teal-600 to-cyan-600"
    },
    {
      icon: <Grid3x3 className="pillar-icon" />,
      title: "Priority Matrix",
      description: "Structured decision‑making to ensure resources align with strategic goals.",
      features: [
        "Impact vs. effort analysis",
        "Resource allocation optimization",
        "Strategic initiative tracking"
      ],
      color: "from-purple-600 to-pink-600"
    }
  ];

  return (
    <section className="leadership-ownership">
      <div className="leadership-ownership-container">
        <div className="section-header-center">
          <span className="section-badge">Leadership & Ownership</span>
          <h2 className="section-title">
            Accountability at Every Level
          </h2>
          <p className="section-description">
            Clear ownership structures and executive alignment ensure your technology investments 
            deliver measurable business value.
          </p>
        </div>

        <div className="ownership-pillars">
          {ownershipPillars.map((pillar, index) => (
            <div key={index} className="ownership-pillar-card">
              <div className={`pillar-header bg-gradient-to-br ${pillar.color}`}>
                <div className="pillar-icon-wrapper">
                  {pillar.icon}
                </div>
                <h3 className="pillar-title">{pillar.title}</h3>
              </div>

              <div className="pillar-content">
                <p className="pillar-description">{pillar.description}</p>
                
                <div className="pillar-features">
                  {pillar.features.map((feature, idx) => (
                    <div key={idx} className="pillar-feature-item">
                      <div className="feature-bullet"></div>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Value Proposition Box */}
        <div className="ownership-value-box">
          <div className="value-box-content">
            <h3 className="value-box-title">
              Why Ownership Matters
            </h3>
            <p className="value-box-text">
              Without clear accountability, technology projects drift. We establish named owners, 
              measurable outcomes, and executive visibility from day one—ensuring your investment 
              delivers predictable results that leadership can track and trust.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipOwnership;